// Free Gift Modal Handler - Same as bonus products
    $(document).on('click', '.free-gift-title', function(){
       var productimg = '';
       var productDesc = '';
       var variantPrice = '';
       var modalHeading = '';
       var modalDesc = '';
       var modalsubDesc = '';
       var productList = '';

       var variantTitle = $('#free-gift-variant-title').text();
       $('#product .container-popup-item-second').hide();
       $('body').css('overflow','hidden');
       productimg = $(this).data('prod-img');
       productDesc = $(this).data('prod-desc');
       variantPrice = 'FREE';
       modalHeading = $(this).data('fheading');
       modalDesc = $(this).data('fdescription');
       modalsubDesc = $(this).data('subfdescription');
       productList = $(this).data('prod-list');

       $('#product .container-popup-item-first img').attr('src',productimg);
       $('#product .container-popup-item-first .right-col .modal-head').html($(this).data('html'));
       $('#product .product-desc').text(productDesc);
       $('#product .container-popup-item-first .right-col .variant-price').html($.trim(variantTitle) + ' - ' + variantPrice);
       $('#product .modal-content h3').html(modalHeading);
       $('#product .modal-content .modal-description').text(modalDesc);
       $('#product .modal-content .submodal-description').text(modalsubDesc);
       $('#product .modal-product-list').html(productList);
       $('#product .modal-product-sale-message').html('');
       $("#product .order").hide();
       $("#product .close-modal-cta").show();
       $('#product .close-modal-cta a').text('CLOSE');
       $('#product .close-modal-cta a').removeAttr('data-value');

       $('#product .modal').show();
       
       return false;
    });

    /**
 * Automatically selects the matching free gift variant based on the main product variant.
 * Matches by size (first part of main variant title before '/').
 * Example: "Twin XL / Soft / No" → matches "Twin XL" gift variant.
 */
function switchFreeGiftVariant(selectedMainVariantTitle) {
  if (!selectedMainVariantTitle) return;
  let selectedTitle = selectedMainVariantTitle.split('/')[0].trim().toLowerCase();
  selectedTitle = selectedTitle.replace(/\(.*?\)/, '').trim();
  const freeGiftVariants = $('#free-gift-variants-data span');
  if (freeGiftVariants.length === 0) return;
  let matchedVariant = freeGiftVariants.filter(function () {
    const variantTitle = ($(this).data('variant-title') || '').trim().toLowerCase();
    return variantTitle === selectedTitle;
  }).first();
  // Whole-word boundary match (backup)
  if (!matchedVariant.length) {
    const boundaryRegex = new RegExp(`\\b${selectedTitle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\b`, 'i');
    matchedVariant = freeGiftVariants.filter(function () {
      const variantTitle = ($(this).data('variant-title') || '').trim().toLowerCase();
      return boundaryRegex.test(variantTitle);
    }).first();
  }
  // Fallback – use first available variant
  if (!matchedVariant.length) {
    matchedVariant = freeGiftVariants.filter(function () {
      const available = $(this).data('variant-available');
      return available === true || available === 'true';
    }).first();
  }
  // Update UI
  if (matchedVariant.length) {
    const variantId = matchedVariant.data('variant-id');
    const variantTitle = matchedVariant.data('variant-title');
    const variantPrice = matchedVariant.data('variant-price');

    $('#free-gift-variant-title').text(variantTitle);
    $('#free-gift-variant-price').text(variantPrice);
    $('#free_gift_radio_input').val(variantId);
  }
}